import { useState } from "react";
import { PharmaStpFileApiResponse } from "../../../api/bigQuery/pharmaStpFileOrders";
import { PharmaStpFileModel } from "../../../data-model/nycbsPharmaOrder";

export interface CallingWorklistTableState {
  data: PharmaStpFileApiResponse | undefined;
  loading: boolean;
  error: string | null;
  showInlineLoader: boolean;
}

export interface UseCallingWorklistTableDataReturn {
  pharmaStpFileState: CallingWorklistTableState;
  setPharmaStpFileState: React.Dispatch<
    React.SetStateAction<CallingWorklistTableState>
  >;
  tableData: PharmaStpFileModel[];
  setTableData: React.Dispatch<React.SetStateAction<PharmaStpFileModel[]>>;
}

export const useCallingWorklistTableData =
  (): UseCallingWorklistTableDataReturn => {
    const [tableData, setTableData] = useState<PharmaStpFileModel[]>([]);
    const [pharmaStpFileState, setPharmaStpFileState] =
      useState<CallingWorklistTableState>({
        data: undefined,
        loading: false,
        error: null,
        showInlineLoader: false,
      });

    return {
      pharmaStpFileState,
      setPharmaStpFileState,
      tableData,
      setTableData,
    };
  };
